import { getCurrentInstance } from 'vue'

export interface NotificationOptions {
  message: string
  type: 'is-primary' | 'is-info' | 'is-success' | 'is-warning' | 'is-danger'
  hasIcon?: boolean
  indefinite?: boolean
  closeable?: boolean
  position?: 'is-top' | 'is-bottom' | 'is-top-right' | 'is-top-left' | 'is-bottom-right' | 'is-bottom-left'
  autoClose?: boolean
  duration?: number
  'data-test-id'?: string
  [key: string]: unknown // Allow additional properties for Buefy compatibility
}

export function useNotifications() {
  const instance = getCurrentInstance()
  
  if (!instance) {
    throw new Error('useNotifications must be called within a setup function')
  }

  const openNotification = (options: NotificationOptions) => {
    const defaultOptions: Partial<NotificationOptions> = {
      hasIcon: true,
      indefinite: true,
      closeable: true,
      position: 'is-top',
    }

    const autoCloseProps: Partial<NotificationOptions> = 
      options.type === 'is-success' 
        ? { autoClose: true, duration: 5000 }
        : {}

    const finalOptions = {
      ...defaultOptions,
      ...options,
      ...autoCloseProps,
    }

    // Access Buefy through the global properties
    const buefy = instance.appContext.config.globalProperties.$buefy
    if (buefy?.notification) {
      buefy.notification.open(finalOptions)
    } else {
      console.error('Buefy notification not available')
    }
  }

  return {
    openNotification,
  }
}